export enum Konvertierungsstatus {
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR'
}
